import sha256 from 'crypto-js/sha256';

let secretToUuidMap = null;

export const ContactService = {

    setSecretToUuidMap: (map) => { secretToUuidMap = (map || {}) },

    getContactUuid: (key) => secretToUuidMap[key] ? secretToUuidMap[key] : null,

    encryptUuid: (uuid) => sha256(uuid).toString()

};

export default ContactService;